import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMerchantPricePointRatioTrend } from '@/shared/model/merchant-price-point-ratio-trend.model';

const baseApiUrl = 'api/merchant-price-point-ratio-trends';
const baseSearchApiUrl = 'api/_search/merchant-price-point-ratio-trends?query=';

export default class MerchantPricePointRatioTrendService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMerchantPricePointRatioTrend> {
    return new Promise<IMerchantPricePointRatioTrend>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantPricePointRatioTrend): Promise<IMerchantPricePointRatioTrend> {
    return new Promise<IMerchantPricePointRatioTrend>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantPricePointRatioTrend): Promise<IMerchantPricePointRatioTrend> {
    return new Promise<IMerchantPricePointRatioTrend>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
